var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Shopping"}},[_c('ListShopping',{staticClass:"mt-4"})],1),_c('vs-tab',{attrs:{"label":"Produtos"}},[_c('ListProdutos',{staticClass:"mt-4"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }